import { inject, Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUser } from "../providers/current-user";
import { ConfigProvider } from "../../config-provider.service";
import { Observable, of, switchMap } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { LangsProvider } from "../providers/langs-provider";

@Injectable({
    providedIn : 'root'
})
export class IsAppReadyService {
  private isReady = false;

  constructor(
    private conf: ConfigProvider,
    private translateService: TranslateService,
    private langs: LangsProvider,
    private currentUser: CurrentUser,
  ) {}
  runIsAppReady() : Observable<boolean | UrlTree> {
    if (this.isReady) {
      return of(true);
    }
    return this.currentUser.tryLoginFromRemember().pipe(
      switchMap((loggedIn) => {
        this.initI18n();
        this.onReady();
        return of(true);
      }),
      catchError(() => {
        this.onReady();
        return of(true);
      })
    );
  }

  private onReady(): void {
    this.translateService.use(this.langs.getBestLangCode());
    this.isReady = true;
  }

  private initI18n(): void {
    const bestLangConfig = this.langs.getBestLangConfig();
    this.translateService.addLangs(this.langs.getLangCodes());
    this.translateService.setDefaultLang(this.conf.defaultLang.code);
    this.langs.selectLang(bestLangConfig);
  }
}

export const IsAppReadyGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  const isAppReadyService = inject(IsAppReadyService);
  return isAppReadyService.runIsAppReady().pipe(
    catchError(error => {
      return of(false);
    })
  );
};


